/**
 * @param {HTMLElement} website
 */
export default function initializeNavigationScroll(website) {
  document.addEventListener('scroll', (e) => {
    if (window.pageYOffset >= 82) {
      if (!website.classList.contains('--scrolled')) {
        website.classList.add('--scrolled');
      }
    } else {
      if (website.classList.contains('--scrolled')) {
        website.classList.remove('--scrolled');
      }
    }
  });
}
